<div class="my-2">
  <div class="d-flex gap-3" [ngClass]="otherParams?.ngClass">
    @for (seg of legendItems; track seg) {
      <div class="legend-item">
        <span
          class="color-box"
          [ngStyle]="{ '--seg-color': seg?.color }"
        ></span>
        <span>{{ seg?.label }}</span>
      </div>
    }
  </div>
  <div class="chart mb-5">
    @for (item of paginatedChartData; track item) {
      <div class="bar-wrapper">
        <div class="bar-label">{{ item?.label }}</div>
        <div class="bar" [style.height.%]="getStackBarHeight(item?.total)">
          @for (seg of item?.segments; track seg) {
            <div
              class="segment"
              [style.flex]="seg?.value + ' 0 0'"
              [ngStyle]="{ '--seg-color': seg?.color }"
            >
              <span
                class="segment-text"
                [ngStyle]="{ '--seg-color': seg?.color }"
              >
                {{ seg?.value }}
              </span>
            </div>
          }
        </div>
        <div class="fw-bold">{{ item?.total }}</div>
      </div>
    }
  </div>
</div>
@if (otherParams?.paginationData) {
  <div class="donotprint">
    <gtapp-pagination-control
      [pageSize]="rows"
      [pageNum]="pageNum"
      [previous]="previousRows"
      [totalRows]="totalRows"
      (onChangePagination)="onChangePagination($event)"
    >
    </gtapp-pagination-control>
  </div>
}
